import moment from 'moment';
import React from 'react';
import { Link } from 'react-router-dom';

import { getUnitList } from '../../actions/MasterAction';
import CONSTANT from './../../constant';
import { onChange, setOptions, validateForm } from './../../utils';

class ComponentName extends React.Component<any, any>{
    constructor(props: any) {
        super(props);

        const detail = props.detail;
        this.state = {
            code: detail ? detail.code : undefined,
            name: { name: 'name', value: detail ? detail.name : '', error: '', isRequired: true },
            date: { name: 'date', value: detail ? moment(detail.date).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD'), error: '', isRequired: true },
            unitCode: { name: 'unitCode', value: detail ? detail.unitCode : '', error: '', isRequired: false, options: [] },
        }
    }

    componentDidMount() {
        getUnitList().then((res: any) => {
            setOptions(this, this.state.unitCode.name, res.result);
        })
    }

    render() {
        const {  name, date, unitCode } = this.state;
        return (
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <div className="card-body">
                            <form onSubmit={this.onSubmit}>
                                <div className="row">
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label>Unit</label>
                                            <select
                                                className={unitCode.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                                name={unitCode.name}
                                                value={unitCode.value}
                                                onChange={this.onChange}
                                            >
                                                <option>Select a Unit</option>
                                                {
                                                    unitCode.options.map(function (item: any, index: number) {
                                                        return (
                                                            <option key={index} value={item.code}>{item.name}</option>
                                                        )
                                                    })
                                                }
                                            </select>
                                            <small>For National holidays leave this blank</small>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label> Date </label>
                                            <input
                                                type="date"
                                                className={date.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                                name={date.name}
                                                value={date.value}
                                                onChange={this.onChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label>Holiday</label>
                                            <input
                                                type="text"
                                                className={name.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                                placeholder="Name of the Holiday"
                                                name={name.name}
                                                value={name.value}
                                                onChange={this.onChange}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-3">
                                        <Link to={CONSTANT.component.adminHolidayList.url} className="btn btn-block cancel-button btn-sm btn-sm">Cancel</Link>
                                    </div>
                                    <div className="col-md-6">
                                        &nbsp;
                                                </div>
                                    <div className="col-md-3">
                                        <button type="submit" className="btn btn-block submit-button btn-sm">Submit</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    onChange = (e: any) => {
        const name = e.target.name;
        const value = e.target.value;

        onChange(this, name, value);
    }

    onSubmit = (e: any) => {
        e.preventDefault();
        if (validateForm(this)) {
            this.setState({ showLoader: true });
            const st = this.state;

            const model: any = {
                name: st.name.value,
                date: st.date.value,
                unitCode: st.unitCode.value === '' ? null : parseFloat(st.unitCode.value)
            }

            if (st.code) {
                model.code = st.code
            }

            this.props.onSubmit(model);
        }
    }
}

export default ComponentName;